import {Question} from '../shared/question';
import {Response} from '../shared/response';

export class OneToOneSegment1Win{

    question1:Question;
    question2:Question;
    question3:Question;
    question4:Question;

    questions: Array<Question>;


    constructor(){
        this.question1 = new Question(1, [], 
            'Winston “Your Freedom” este o campanie online in care ai dori sa participi in viitorul apropiat? Participarea presupune introducerea pe site a codurilor din pachet, pentru castigarea de premii',
            'In cursul lunii septembrie, ai primit din partea Winston un pachet gratuit, pe care l-ai revendicat din magazin. Pentru a intra in posesia pachetului, ai folosit un cod de revendicare, disponibil in sectiunea “Contul meu”, de pe platforma Winston “Your Freedom”',
            'radio',
            [new Response(1, 'Da'), 
            new Response(2, 'Nu')
            ],
            false
        );
        
        this.question2 = new Question(2, [1],
            'Participi in campanii promotionale, in general, indiferent de categorie sau produs',
            '',
            'radio',
            [new Response(1, 'Da'), 
            new Response(2, 'Nu')
            ],
            false
        );
    
        this.question2.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            return question1SelectedIds.length> 0 && question1SelectedIds.indexOf(2) >= 0;
        }

        this.question3 = new Question(3, [1,2],
            'Exista ceva care nu-ti place la platforma Winston “Your Freedom”, astfel incat sa nu participi? Daca da, ce anume?',
            '',
            'checkbox-free',
            [new Response(1, 'Prea putine premii'), 
            new Response(2, 'Premiile nu sunt atractive'),
            new Response(3, 'Sansele de castig sunt foarte mici'),
            new Response(4, 'Aspectul site-ului'),
            new Response(5, 'Dificultatea mecanicilor'),
            new Response(6, 'Nu fumez acest brand suficient de des'),
            new Response(7, 'Nu sunt interesat de campaniile promotionale pentru produse din tutun'),
            new Response(8, 'Nu exista nimic care sa nu-mi placa'),
            new Response(9, 'Altele'),
            ],
            false
        );

        this.question3.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            let question2SelectedIds = this.getSelectedAnswersIds(this.question2);
            return (question1SelectedIds.length> 0 && question1SelectedIds.indexOf(1) >= 0) || 
                (question2SelectedIds.length > 0 && question2SelectedIds.indexOf(1) >= 0);
        }

        this.question4 = new Question(4, [2, 3],
            'Exista un factor care te-ar face sa te razgandesti? Daca da, care?',
            '',
            'checkbox-free',
            [new Response(1, 'Nu'),
            new Response(2, 'Da')
            ],
            true
        );
        this.question4.render = ()=>{
            let question2SelectedIds = this.getSelectedAnswersIds(this.question2);
            return question2SelectedIds.length > 0 && question2SelectedIds.indexOf(2)>=0;
        }

        

        this.questions = [this.question1, this.question2, this.question3, this.question4];
    }

    
    getQuestions():Array<Question>{
        return this.questions;
    }

    getSelectedAnswersIds(question:Question):Array<Number>{
        return question.responses.filter(r => r.selected).map(r => r.id);
    } 
    
}

